import { Outlet } from "react-router-dom";
import { SidebarProvider } from "../ui/sidebar";
import { Suspense } from "react";
import { AuthProvider } from "../../store/contexts/AuthContext";
import StateManager from "../common/StateManager";
import { TooltipProvider } from "../ui/tooltip";
import { Toaster } from "sonner";
import SkeletonLoader from "../common/SkeletonLoader";
import ReportBugButton from "../common/ReportBugButton";
import MigrationBanner from "../common/MigrationBanner";

const RootLayout = () => {
  return (
    <AuthProvider>
      <SidebarProvider>
        <TooltipProvider>
          <StateManager />
          <Toaster />
          <Suspense fallback={<SkeletonLoader />}>
            <Outlet />
          </Suspense>
          <ReportBugButton />
          <MigrationBanner />
        </TooltipProvider>
      </SidebarProvider>
    </AuthProvider>
  );
};

export default RootLayout;
